import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-testid"]
const _hoisted_2 = ["data-testid"]
const _hoisted_3 = { class: "m-0 flex items-center justify-between gap-2 text-[13px] font-bold text-textPrimary" }
const _hoisted_4 = { class: "font-medium tabular-nums text-neutral50" }
const _hoisted_5 = ["data-testid"]
const _hoisted_6 = {
  key: 2,
  class: "m-0 text-xs text-neutral50"
}
const _hoisted_7 = ["disabled", "aria-busy", "aria-label", "data-testid", "onClick"]

import { computed } from 'vue'

import { QUEUE_TONE_BORDER_CLASS } from './types'
import type { QueueKanbanColumn } from './types'

type ResolvedColumn = QueueKanbanColumn<T> & { rows: T[] }


export default /*#__PURE__*/_defineComponent({
  __name: 'QueueKanban',
  props: {
    rows: {},
    columns: {},
    rowKey: {},
    emptyColumnText: { default: 'Nada aqui.' },
    testId: { default: 'queue-kanban' },
    columnTotals: { default: undefined },
    columnHasMore: { default: undefined },
    columnLoading: { default: undefined }
  },
  emits: ["load-more"],
  setup(__props: any, { emit }) {

const props = __props;







/**
 * Cada linha entra na PRIMEIRA coluna cujo predicado casa. Uma passada só,
 * em vez de um `filter` por coluna: assim um predicado mal escrito duplica
 * nada — e o que não casa em coluna nenhuma fica evidente para quem define as
 * colunas (é o pai que garante a cobertura total).
 */
const headerCount = (column: ResolvedColumn): number =>
  props.columnTotals?.[column.key] ?? column.rows.length

const isColumnLoading = (key: string): boolean => props.columnLoading?.[key] === true

const loadMoreLabel = (column: ResolvedColumn): string =>
  `Ver mais em ${column.title} (${column.rows.length} de ${headerCount(column)})`

function onLoadMore(key: string): void {
  if (isColumnLoading(key)) return
  emit('load-more', key)
}

const resolvedColumns = computed(() => {
  const buckets: ResolvedColumn[] = props.columns.map((column) => ({ ...column, rows: [] as T[] }))
  for (const row of props.rows) {
    const bucket = buckets.find((candidate) => candidate.matches(row))
    if (bucket) bucket.rows.push(row)
  }
  return buckets
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "grid grid-flow-col auto-cols-[minmax(250px,1fr)] items-start gap-3 overflow-x-auto pb-1.5",
    "data-testid": _ctx.testId
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resolvedColumns.value, (column) => {
      return (_openBlock(), _createElementBlock("section", {
        key: column.key,
        class: _normalizeClass(["flex flex-col gap-2 rounded-lg border-t-[3px] bg-lightGray30/40 p-2.5", _unref(QUEUE_TONE_BORDER_CLASS)[column.tone ?? 'neutral']]),
        "data-testid": `${_ctx.testId}-column-${column.key}`
      }, [
        _createElementVNode("h3", _hoisted_3, [
          _renderSlot(_ctx.$slots, "column-title", { column: column }, () => [
            _createTextVNode(_toDisplayString(column.title), 1)
          ]),
          _createElementVNode("span", _hoisted_4, _toDisplayString(headerCount(column)), 1)
        ]),
        (column.hint)
          ? (_openBlock(), _createElementBlock("p", {
              key: 0,
              class: "m-0 text-[11px] text-neutral50",
              "data-testid": `${_ctx.testId}-column-${column.key}-hint`
            }, _toDisplayString(column.hint), 9, _hoisted_5))
          : _createCommentVNode("", true),
        (column.rows.length)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(column.rows, (row) => {
              return _renderSlot(_ctx.$slots, "card", {
                key: _ctx.rowKey(row),
                row: row
              })
            }), 128))
          : (!_ctx.columnHasMore?.[column.key])
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.emptyColumnText), 1))
            : _createCommentVNode("", true),
        (_ctx.columnHasMore?.[column.key])
          ? (_openBlock(), _createElementBlock("button", {
              key: 3,
              type: "button",
              class: "rounded border border-lightGray30 bg-white px-2.5 py-1.5 text-xs font-medium text-primary hover:border-primary disabled:cursor-wait disabled:opacity-60",
              disabled: isColumnLoading(column.key),
              "aria-busy": isColumnLoading(column.key) ? 'true' : 'false',
              "aria-label": loadMoreLabel(column),
              "data-testid": `${_ctx.testId}-column-${column.key}-load-more`,
              onClick: ($event: any) => (onLoadMore(column.key))
            }, _toDisplayString(isColumnLoading(column.key) ? 'Carregando…' : 'Ver mais'), 9, _hoisted_7))
          : _createCommentVNode("", true)
      ], 10, _hoisted_2))
    }), 128))
  ], 8, _hoisted_1))
}
}

})